import React, { useState, useEffect, ChangeEventHandler, FocusEventHandler, forwardRef, useImperativeHandle } from "react";

interface IPropsType {
    label: string,
    name: string,
    value: string,
    required: boolean,
    tooltipText?: string,
    placeholder?: string,
    errorMessage?: string,
    columnClass?: string,
    className?: string
}

function textArea2(props: IPropsType, ref) {
    const [isValid, setIsValid] = useState(true);
    const stdInputClass = (!isValid && props.errorMessage ? " is-invalid" : "") + " form-control auto-height-form-control app-form-control";
    const [value, setValue] = useState(props.value);

    useImperativeHandle(ref, () => ({

        validate() {
            setIsValid(true);
            console.log('textArea2 ' + props.name + ' validate value=', value);
            if (value == null || value == '' && props.required) {
                setIsValid(false);
                return false;
            }
            return true;
        },

        getData() {
            return value;
        }
    }));

    return (
        <div className={`inputWrapper ${props.className}`}>
            <span>{props.label}</span>
            <textarea required
                name={props.name}
                onChange={(e) => { setValue(e.target.value); }}
                placeholder={props.placeholder}
                cols={30}
                rows={6}
                defaultValue={value}>
            </textarea>
            {!isValid && props.errorMessage && <p className="errorText">{props.errorMessage}</p>}
        </div>
        
        //<div className="form-group">
        //    <label {...(props.tooltipText ? { "data-toggle": "tooltip", title: props.tooltipText } : {})}>
        //        {props.label} {props.required && <span className="requirement">(*)</span>}:
        //    </label>
            //<textarea
            //    name={props.name}
            //    onChange={props.onChange}
            //    onBlur={props.onBlur}
            //    className="form-control custom-field" >
            //    {props.value}
            //</textarea>

        //    {!props.removeValidationMsg && <ErrorMessage name={props.name} component="span" className="field-validation-error"/>}
        //</div>
    );

}

export default textArea2 = forwardRef(textArea2);